module.exports = __webpack_public_path__ + "img/box1.e7c3a7a0.jpg";